/**
 * Utility functions for call-related operations
 */

/**
 * Generates a LiveKit room name in the format: user_{phoneNumberId}_calling_coming_{customerPhone}
 */
export function generateRoomName(phoneNumberId: string, customerPhone: string): string {
  if (!phoneNumberId || !customerPhone) {
    throw new Error('phoneNumberId and customerPhone are required');
  }
  const cleanPhone = customerPhone.replace(/[^\d]/g, '');
  return `user_${phoneNumberId}_calling_coming_${cleanPhone}`;
}

/**
 * Validates and cleans a phone number
 */
export function cleanPhoneNumber(phone: string): string {
  return phone.replace(/[^\d]/g, '');
}

/**
 * Gets phone number ID from session storage
 */
export function getPhoneNumberId(): string {
  return sessionStorage.getItem('phoneNumberId') || '';
}

/**
 * Stores incoming call data in session storage
 */
export function storeIncomingCallData(data: {
  callerId: string;
  callerPhone: string;
  roomName?: string;
  callStatus?: string;
  calleeId?: string;
}) {
  sessionStorage.setItem('selectedCustomer', JSON.stringify({
    phone: data.callerPhone,
    name: data.callerId || data.callerPhone
  }));

  if (data.roomName) {
    sessionStorage.setItem('incomingCallRoomName', data.roomName);
  }

  // Always set incoming call status - default to 'incoming' if not provided
  const callStatus = data.callStatus || 'incoming';
  sessionStorage.setItem('incomingCallStatus', callStatus);

  if (data.calleeId && data.callerId) {
    sessionStorage.setItem('incomingCallCalleeId', data.calleeId);
    sessionStorage.setItem('incomingCallCallerId', data.callerId);
  }

  // Dispatch custom event to notify components about incoming call update
  window.dispatchEvent(new CustomEvent('incomingCallUpdated'));
}

/**
 * Clears incoming call data from session storage
 */
export function clearIncomingCallData() {
  sessionStorage.removeItem('incomingCallStatus');
  sessionStorage.removeItem('incomingCallRoomName');
  sessionStorage.removeItem('incomingCallCalleeId');
  sessionStorage.removeItem('incomingCallCallerId');
}
